import { Link } from "react-router-dom";
import { resolveMediaUrl } from "../lib/api";

export default function DossierCard({ dossier }) {
  const count = String(dossier.item_count || 0).padStart(3, "0");
  return (
    <Link
      to={`/dossiers/${dossier.slug}`}
      data-testid={`dossier-card-${dossier.slug}`}
      className="tile group"
    >
      <span className="tile-corner-badge">{count} ITEMS</span>
      <span className="tile-corner-badge-type">DOSSIER</span>

      {dossier.cover_image ? (
        <img
          src={resolveMediaUrl(dossier.cover_image)}
          alt={dossier.title}
          className="tile-media"
        />
      ) : (
        <div className="tile-placeholder">{dossier.title.slice(0, 2).toUpperCase()}</div>
      )}

      <div className="tile-overlay">
        <div className="mono text-[10px] uppercase tracking-[0.14em] text-white/80">
          /{dossier.slug}
        </div>
        <div className="heavy text-white text-2xl leading-tight mt-1 line-clamp-2">
          {dossier.title}
        </div>
      </div>
    </Link>
  );
}
